import script from "./XiaomiSign.vue?vue&type=script&setup=true&lang=ts"
export * from "./XiaomiSign.vue?vue&type=script&setup=true&lang=ts"

import "./XiaomiSign.vue?vue&type=style&index=0&id=2862b8f4&lang=css"

const __exports__ = script;

export default __exports__